export default __webpack_public_path__ + "static/media/oscer-pres-abdominal-pain.ddd341eb.svg";